import {
  Divider,
  List,
  ListItemButton,
  Popover,
} from '@mui/material';
import styles from './ccf-interactions-filter-popover.module.scss';
import { CcfBox, CcfTypography } from '@nice-ccf/ui-controls';

/* eslint-disable-next-line */
export interface CcfInteractionsFilterPopoverProps {
  anchorEl: any;
  handlePopoverClose: any;
  handleFilter: any;
  selectedFilterOption: any;
}

/**
 * CcfInteractionsFilterPopover - returns Datewise Filter popover for interactions
 * @param props - CcfInteractionsFilterPopoverProps
 * @example - `<CcfInteractionsFilterPopover />`
 */
export function CcfInteractionsFilterPopover(
  props: CcfInteractionsFilterPopoverProps
) {
  const { anchorEl, handlePopoverClose, handleFilter, selectedFilterOption } =
    props;
  const filters = [
    'all',
    'today',
    'yesterday',
    'lastWeek',
    'lastMonth',
    'last90Days',
  ];

  return (
    <Popover
      id="interaction-filter-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <CcfBox className={styles.popoverContainer}>
        <CcfBox>
          <CcfTypography
            className={styles.selectDateRangeTxt}
            translationKey={'selectDateRange'}
          />
        </CcfBox>
        {filters.map((filter, index) => (
          <List
            style={{ padding: '5px 0px' }}
            component="nav"
            aria-label="appSpaceMenu"
          >
            <ListItemButton
              aria-label={'appSpaceMenu-MiniMizePanel'}
              style={{
                backgroundColor:
                  filter === selectedFilterOption ? '#ebebeb' : '#ffffff',
                padding: '0px',
              }}
              id="agent_filter_popOver_minimizePanel"
              onClick={() => {
                handleFilter(filter);
              }}
            >
              <CcfTypography
                translationKey={filter}
                className={styles.menuTxt}
              ></CcfTypography>
            </ListItemButton>
          </List>
        ))}
        <Divider style={{ margin: '10px 0px' }} />
        <CcfBox>
          <CcfTypography
            className={styles.customDateRangeTxt}
            translationKey={'customDateRange'}
          />
        </CcfBox>
      </CcfBox>
    </Popover>
  );
}

export default CcfInteractionsFilterPopover;
